import {NgModule} from '@angular/core';
import {PhoneInputComponent} from "./phone-input.component";
import {IonicModule} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {SelectFilterModule} from "../../../../../components/common/select-filter/select-filter.module";
import {InputTextModule} from "../../../../core/component/input-text/input-text.module";

@NgModule({
    declarations: [
        PhoneInputComponent,
    ],
    exports: [
        PhoneInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        SelectFilterModule,
        InputTextModule,
    ]
})
export class PhoneInputModule {}
